/**
 * @file Route: ethics
 *
 * This file is compiled as a standalone entrypoint and it is included by
 * default in its blade template.
 * This is a "standard" route, it does not have a structure to follow, you are
 * sure the DOM is always ready and the JS will only be executed in this route.
 */

 import "layouts/main";
 import { $all } from "@olmokit/dom";
 import { globalData } from "@olmokit/core/data";
 import "components/Cover";
 import "components/VisualText";
 import "components/VisualDownload";
import { replaceFragment } from "@olmokit/core/fragments";
import { FormType } from "components/Form";
 import "./index.scss";

console.log("Route ethics/index.js mounted.");
 
replaceFragment("contactForm", "components.FormType").then(() => FormType());
